import { clsx } from 'clsx'
import { type ReactNode } from 'react'
import { Backlink } from '#app/components/layout/backlink.tsx'

export function PageTitle({
	titleText,
	className,
	actionComponent,
	backlink,
	backlinkLabel,
}: {
	titleText: string
	className?: string
	actionComponent?: ReactNode
	backlink?: string
	backlinkLabel?: string
}) {
	return (
		<>
			<div
				className={clsx(
					`bg-pcteal-default items-middle top-0 z-10 flex w-full justify-between py-2`,
					className,
					!backlink && 'mb-8',
				)}
			>
				<div className="mx-auto flex w-full max-w-screen-2xl items-center justify-between px-2 md:px-4">
					<h1 className="font-alumni font-h2 text-clamp-md md:text-clamp-lg font-semibold text-white">
						{titleText}
					</h1>
					{actionComponent}
				</div>
			</div>
			{backlink && <Backlink to={backlink} label={backlinkLabel} />}
		</>
	)
}
